<template>
    <div class="result-container flex-col">
      <div class="row flex-row red">
        <span :class="{highlight: !getHighlightClass('I', 'E')}">外倾(E)</span>
        <div class="bar">
          <div
            class="progress"
            :class="getProgressClass('E', 'I')"
            :style="{ width: `${calculateWidth('E', 'I')}%` }"
          >
            {{ getDisplayValue('E', 'I') }}
          </div>
        </div>
        <span :class="{highlight: getHighlightClass('I', 'E')}">内倾(I)</span>
      </div>
      <div class="row flex-row green">
        <span :class="{highlight: getHighlightClass('S', 'N')}">实感(S)</span>
        <div class="bar">
          <div
            class="progress"
            :class="getProgressClass('S', 'N')"
            :style="{ width: `${calculateWidth('S', 'N')}%` }"
          >
            {{ getDisplayValue('S', 'N') }}
          </div>
        </div>
        <span :class="{highlight: !getHighlightClass('S', 'N')}">直觉(N)</span>
      </div>
      <div class="row flex-row blue">
        <span :class="{highlight: getHighlightClass('T', 'F')}">思维(T)</span>
        <div class="bar">
          <div
            class="progress"
            :class="getProgressClass('T', 'F')"
            :style="{ width: `${calculateWidth('T', 'F')}%` }"
          >
            {{ getDisplayValue('T', 'F') }}
          </div>
        </div>
        <span :class="{highlight: !getHighlightClass('S', 'N')}">情感(F)</span>
      </div>
      <div class="row flex-row orange">
        <span :class="{highlight: getHighlightClass('J', 'P')}">判断(J)</span>
        <div class="bar">
          <div
            class="progress"
            :class="getProgressClass('J', 'P')"
            :style="{ width: `${calculateWidth('J', 'P')}%` }"
          >
            {{ getDisplayValue('J', 'P') }}
          </div>
        </div>
        <span :class="{highlight: !getHighlightClass('J', 'P')}">知觉(P)</span>
      </div>
      <div class="table">
        <div class="table-row header">
            <div class="cell">E</div>
            <div class="cell">S</div>
            <div class="cell">T</div>
            <div class="cell">J</div>
            <div class="cell">I</div>
            <div class="cell">N</div>
            <div class="cell">F</div>
            <div class="cell">P</div>
        </div>
        <div class="table-row">
            <div class="cell">{{ scores.E }}</div>
            <div class="cell">{{ scores.S }}</div>
            <div class="cell">{{ scores.T }}</div>
            <div class="cell">{{ scores.J }}</div>
            <div class="cell">{{ scores.I }}</div>
            <div class="cell">{{ scores.N }}</div>
            <div class="cell">{{ scores.F }}</div>
            <div class="cell">{{ scores.P }}</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    props: {
        scores: {
            type: Object,
            required: true,
        },
    },
    methods: {
        calculateWidth(leftKey, rightKey) {
            const left = this.scores[leftKey] || 0;
            const right = this.scores[rightKey] || 0;
            const total = left + right;

            return total > 0 ? (Math.max(left, right) / total) * 50 : 0;
        },

        getDisplayValue(leftKey, rightKey) {
            const left = this.scores[leftKey] || 0;
            const right = this.scores[rightKey] || 0;
            return Math.max(left, right);
        },

        getProgressClass(leftKey, rightKey) {
            const left = this.scores[leftKey] || 0;
            const right = this.scores[rightKey] || 0;
            return left >= right ? 'progress-left' : 'progress-right';
        },

        getHighlightClass(leftKey, rightKey) {
            const left = this.scores[leftKey] || 0;
            const right = this.scores[rightKey] || 0;
            return left >= right;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@s/common.scss";

.result-container {
    margin-top: 0.72rem;
    gap: 0.4rem;
    .row {
        align-items: center;
        justify-content: center;
        color: rgba(6, 16, 41, 0.3);
        font-size: 0.32rem;
        font-weight: normal;
        text-align: justify;
        white-space: nowrap;
        &.red {
            .highlight {
                color: #FD5D4A;
            }
            .progress-right {
                background: linear-gradient( 90deg, #FFA17D 0%, #FD5D4A 100%);
            }
            .progress-left {
                background: linear-gradient( -90deg, #FFA17D 0%, #FD5D4A 100%);
            }
        }
        &.orange {
            .highlight {
                color: #FF9340;
            }
            .progress-right {
                background: linear-gradient( 90deg, #FDCC34 0%, #FF9340 100%);
            }
            .progress-left {
                background: linear-gradient( -90deg, #FDCC34 0%, #FF9340 100%);
            }
        }
        &.green {
            .highlight {
                color: #15C7B6;
            }
            .progress-right {
                background: linear-gradient( 90deg, #76FDCD 0%, #40EADD 100%);
            }
            .progress-left {
                background: linear-gradient( -90deg, #76FDCD 0%, #40EADD 100%);
            }
        }
        &.blue {
            .highlight {
                color: #3077FF;
            }
            .progress-right {
                background: linear-gradient( 90deg, #4AD5FB 0%, #0C53FC 100%);
            }
            .progress-left {
                background: linear-gradient( -90deg, #4AD5FB 0%, #0C53FC 100%);
            }
        }
        .bar {
          width: 4.27rem;
          height: 0.37rem;
          background: #EEF0F2;
          border-radius: 0.19rem;
          margin: 0 0.294rem;
          position: relative;

          .progress {
            position: absolute;
            height: 0.37rem;
            font-size: 0.27rem;
            color: #FFFFFF;
            line-height: 0.37rem;
            font-weight: bold;
            box-sizing: border-box;
            top: 0;

            &.progress-right {
                border-radius: 0rem 0.19rem 0.19rem 0rem;
                left: 50%;
                text-align: right;
                padding-right: 0.19rem;
            }

            &.progress-left {
                border-radius: 0.19rem 0rem 0rem 0.19rem;
                right: 50%;
                text-align: left;
                padding-left: 0.19rem;
            }
          }
        }
      }
    
    .table {
        background: #fff;
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 0.427rem;

        .table-row {
            display: flex;
            flex-direction: row;
            gap: 1px;

            .cell {
                background-color: #F5F5F5;
                height: 0.8rem;
                line-height: 0.8rem;
                text-align: center;
                font-size: 0.32rem;
                color: #333333;
                font-weight: bold;
                flex: 1;
                flex-grow: 1;
            }

            &.header .cell {
                background-color: #3077FF;
                color: #fff;
                font-size: 0.4rem;
            }
        }
    }
}
</style>